import { Typography as MuiTypography } from '@material-ui/core';
import { styled, withStyles } from '@material-ui/core/styles';

import { COLORS } from 'theme/constants';

import { ReactComponent as CozmosSVGWhite } from 'assets/img/cozmos-logo.svg';
import mobileBackground from 'assets/img/builder_mobile_bg.png';

export const GlobalStyle = withStyles({
  // @global is handled by jss-plugin-global.
  '@global': {
    'html, body, #root': {
      height: '100%',
    },
  },
})(() => null);

export const Root = styled('div')({
  position: 'relative',
  justifyContent: 'center',
  alignItems: 'stretch',
  display: 'flex',
  minHeight: '100%',
  '& > .MuiGrid-root': {
    background: 'linear-gradient(-30deg, rgba(70, 65, 243, 1) 0%, rgba(168, 71, 255, 1) 100%)',
    backgroundSize: 'cover',
  },
});

export const PageWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: '12px',
  color: theme.palette.auth.formText,
  fontFamily: 'GothamBook',
  '& .MuiGrid-spacing-xs-6 > .MuiGrid-item.p0': {
    padding: 0,
  },
}));

export const CozmosLogoLight = styled(CozmosSVGWhite)(({ theme }) => ({
  display: 'block',
  width: '238px',
  height: '64px',
}));

export const Title = styled(MuiTypography)({
  color: COLORS.white,
  fontFamily: 'GothamBold',
  fontSize: '39px',
  lineHeight: 0.9,
  fontWeight: 900,
});

export const MobileBackground = styled('div')({
  minHeight: '100vh',
  width: '100%',
  background: `url(${mobileBackground}) no-repeat`,
  backgroundColor: '#1a1a1d',
  backgroundSize: '100% 40%',
  backgroundPosition: 'center top',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
